import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalDirectivesModule } from '@app/directives/global-directives.module';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { IconsModule } from '@app/components/kit/icons/icons.module';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AlertOutline, CommentOutline } from '@ant-design/icons-angular/icons';

import { QueryStatePipe } from 'src/app/workflow/queries/query-state/query-state.pipe';
import { QuestionLabelPipe } from './question-label/question-label.pipe';

import { SelectableQuestionComponent } from '@workflow/queries/selectable-question/selectable-question.component';
import { SelectQuestionInputComponent } from '@workflow/queries/select-question-input/select-question-input.component';
import { QueryPanelComponent } from '@workflow/queries/query-panel/query-panel.component';
import { QueryStateComponent } from '@workflow/queries/query-state/query-state.component';
import { QueryEditComponent } from './query-edit/query-edit.component';
import { QueryCreateComponent } from './query-create/query-create.component';
import { QueryTimelineComponent } from './query-timeline/query-timeline.component';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { ValueSelectDirective } from '@workflow/queries/value-select/value-select.directive';
import { QueryEditActionsDirective } from './query-edit/query-edit-actions.directive';

const EXPORTS: Type<unknown>[] = [
	SelectableQuestionComponent,
	SelectQuestionInputComponent,
	QueryPanelComponent,
	QueryStateComponent,
	QueryStatePipe,
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		GlobalDirectivesModule,
		NzTabsModule,
		NzButtonModule,
		NzFormModule,
		NzInputModule,
		NzBadgeModule,
		NzIconModule.forChild([AlertOutline, CommentOutline]),
		IconsModule,
	],
	declarations: [
		...EXPORTS,
		QuestionLabelPipe,
		QueryEditComponent,
		QueryCreateComponent,
		QueryTimelineComponent,
		ValueSelectDirective,
		QueryEditActionsDirective,
	],
	exports: EXPORTS,
})
export class QueriesModule {}
